import { supabase } from '@/integrations/supabase/client';
import {
  SaveUserExportParams,
  SaveUserExportResult,
} from '@/constants/userExports';
import { saveUserExport } from '@/services/userExportsService';

/** Enregistre un export dans Mes Exports (cloud si connecté, sinon appareil). */
export async function saveUserExportFromTool(
  params: SaveUserExportParams
): Promise<SaveUserExportResult> {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  return saveUserExport(user?.id ?? null, params);
}
